import { useId } from 'react';
import { ComposerEditor } from './composerEditor/ComposerEditor';

export const SIGNATURE_HELP =
  "Added to the end of every email sent from this mailbox, unless the email already signs off or its template has its own signature. Links aren't allowed, because a first email never contains a link.";

export const TEMPLATE_SIGNATURE_HELP =
  "When set, mails from this template use this signature instead of the mailbox signature. Leave it empty to use the mailbox signature. It isn't added when the email already signs off. Links aren't allowed, because a first email never contains a link.";

export interface SignatureEditorProps {
  /** Seed formatting, read once on mount; wins over initialText. */
  initialHtml?: string;
  initialText?: string;
  /** The text and the HTML the server stores ('' once the signature has no words). */
  onChange: (text: string, html: string) => void;
  ariaLabel?: string;
  disabled?: boolean;
  /** The line under the box; the mailbox wording by default. */
  help?: string;
}

/** A mailbox or template signature, written with the composer's editor (owner 2026-10-12), without the Link button. */
export function SignatureEditor({ initialHtml, initialText, onChange, ariaLabel = 'Signature', disabled = false, help = SIGNATURE_HELP }: SignatureEditorProps) {
  const noteId = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <div className="overflow-hidden rounded-md border border-input">
        <ComposerEditor
          ariaLabel={ariaLabel}
          ariaDescribedBy={noteId}
          autoFocus={false}
          liveRegion={false}
          allowLink={false}
          editable={!disabled}
          initialHtml={initialHtml}
          initialText={initialText}
          placeholder="— Neha, Partnerships at Discovr"
          onChange={onChange}
          onSubmitShortcut={() => undefined}
          renderFooter={(toolbar) => <div className="border-t border-border bg-[#fafafa] px-3 py-2">{toolbar}</div>}
        />
      </div>
      <p id={noteId} className="text-caption-regular text-muted-foreground">
        {help}
      </p>
    </div>
  );
}
